export const accent = '#f90000';
